import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { Button, Card } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../common/components/icons/AntIcon";
import { AgentEducationFilterForm } from "../components/forms/AgentEducationFIlterForm";
import { AgentEducationModalForm } from "../components/forms/AgentEducationModalForm";
import { AgentEducationTable } from "../components/tables/AgentEducationTable";
import { AgentEducation } from "../types";

export const AgentEducationContainer = () => {
  const { t } = useTranslation();

  const [isOpenModalForm, setIsOpenModalForm] = useState(false);

  const [education, setEducation] = useState<AgentEducation>();

  const handleCancelModalForm = () => {
    setEducation(undefined);
    setIsOpenModalForm(false);
  };

  const handleChangeAgentEducation = (education: AgentEducation) => {
    setEducation(education);
    setIsOpenModalForm(true);
  };

  const handleClickCreateAgentEducation = () => {
    setEducation(undefined);
    setIsOpenModalForm(true);
  };

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={<h2>{t("agent.education.titles.admin")}</h2>}
        extra={
          <Button type="primary" icon={<AntIcon type="plus" />} onClick={handleClickCreateAgentEducation}>
            {t("agent.actions.addAgentEducation")}
          </Button>
        }
      >
        <AgentEducationFilterForm />
      </Card>

      <Card className="card-box">
        <AgentEducationTable onChange={handleChangeAgentEducation} />
      </Card>

      <AgentEducationModalForm isOpen={isOpenModalForm} education={education} onCancel={handleCancelModalForm} />
    </ContentWrapper>
  );
};
